"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var enquiryFormTitleStyles = makeStyles_1.default(function (_a) {
    var _b;
    var typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        title: (_b = {
                textAlign: 'center',
                marginLeft: 'inherit',
                fontFamily: typography.fontFamily2,
                margin: '16px auto 28px'
            },
            _b[breakpoints.down('sm')] = {
                padding: '0 8px',
                margin: '16px auto 4px',
            },
            _b),
        titleContent: {},
    });
}, { name: 'GqlCheckout_EnquiryFormTitle' });
exports.default = enquiryFormTitleStyles;
